var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    width: 60,
    height: 60,
    style: {},
    filter: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8 14c0.6 0 1-0.4 1-1s-0.4-1-1-1-1 0.4-1 1 0.4 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4h-12v12l16 16 12-12-16-16zM12.8 10c1.6 0 3 1.4 3 3s-1.2 3-3 3c-1.6 0-3-1.4-3-3s1.4-3 3-3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSon);
export default __webpack_public_path__ + "static/media/son.db85cce4d3d5fb17220c82d1f52c208b.svg";
export { ForwardRef as ReactComponent };